<!-- 刷脸系统 -->
<template>
  <div class="warp">
    <div class="banner">
      <br />
      <p>绿茶刷脸支付系统</p>
      <span>
        打造智慧零售智能化
        <br />收银管理平台
      </span>
      <a class="button-text" target="_blank" href="https://work.weixin.qq.com/kfid/kfc4a1a89c3395408e9">微信客服</a>
    </div>
    <div class="face1">
      <div class="title">多种支付解决方案，满足不同商家需求</div>
      <ul>
        <li>
          <img src="../../assets/images/face02.png" />
          <span>支付宝刷脸支付</span>
          <p>支持接入支付宝进行付款、收款、退款</p>
        </li>
        <li>
          <img src="../../assets/images/face03.png" />
          <span>微信刷脸支付</span>
          <p>接入微信小程序收款交易更快捷</p>
        </li>
        <li>
          <img src="../../assets/images/face04.png" />
          <span>商户收款APP</span>
          <p>手机版“智能收银台”轻松实现移动收款</p>
        </li>
        <li>
          <img src="../../assets/images/face05.png" />
          <span>聚合码支付</span>
          <p>聚合微信支付、支付宝二维码，实现一码收款</p>
        </li>
        <li>
          <img src="../../assets/images/face06.png" />
          <span>智能POS机</span>
          <p>覆盖刷卡消费人群适用更多场景</p>
        </li>
        <li>
          <img src="../../assets/images/face07.png" />
          <span>扫码枪</span>
          <p>扫码自动核销实现快速收付款</p>
        </li>
      </ul>
    </div>
    <div class="face2">
      <div class="title">刷脸即可完成支付，提升购物体验</div>
      <img src="../../assets/images/face08.jpg" />
    </div>

    <div class="face3">
      <div class="title">标准化管理矩阵，快速提高管理效率</div>
      <div class="img">
        <img src="../../assets/images/face09.jpg" />
      </div>
      <ul>
        <li>
          <div class="left">
            <img src="../../assets/images/face11.jpg" />
          </div>
          <div class="right">
            <span>角色管理</span>
            <p>服务商、运营商、渠道商、商户，多角色一站式管理更轻松</p>
          </div>
        </li>
        <li>
          <div class="left">
            <img src="../../assets/images/face11.jpg" />
          </div>
          <div class="right">
            <span>营销管理</span>
            <p>完善的营销工具管理体系，帮助商户高效进行活动营销</p>
          </div>
        </li>
        <li>
          <div class="left">
            <img src="../../assets/images/face11.jpg" />
          </div>
          <div class="right">
            <span>支付管理</span>
            <p>订单查询、收款退款、交易数据智能管理，对账更便捷</p>
          </div>
        </li>
        <li>
          <div class="left">
            <img src="../../assets/images/face11.jpg" />
          </div>
          <div class="right">
            <span>数据管理</span>
            <p>平台数据多维展示，运营情况一目了然，助力试下精细化运营</p>
          </div>
        </li>
      </ul>
    </div>

    <div class="face3">
      <div class="title">刷脸支付+营销，升级交易体验</div>
      <div class="img">
        <img src="../../assets/images/face10.jpg" />
      </div>
      <ul>
        <li>
          <div class="left">
            <img src="../../assets/images/face12.jpg" />
          </div>
          <div class="right">
            <span>支付+广告</span>
            <p>支持APP广告、付款后跳转广告，丰富的计费模式及广告形式</p>
          </div>
        </li>
        <li>
          <div class="left">
            <img src="../../assets/images/face12.jpg" />
          </div>
          <div class="right">
            <span>支付+积分</span>
            <p>刷脸支付可获积分、积分可用于换购礼品，激发用户使用欲望</p>
          </div>
        </li>
        <li>
          <div class="left">
            <img src="../../assets/images/face12.jpg" />
          </div>
          <div class="right">
            <span>支付+发票</span>
            <p>交易成功后，可直接打印发票，缩短开票等待时间，体验更好</p>
          </div>
        </li>
        <li>
          <div class="left">
            <img src="../../assets/images/face12.jpg" />
          </div>
          <div class="right">
            <span>支付+卡券</span>
            <p>支持优惠卡券发放，助力引流聚粉，快速实现二次交易</p>
          </div>
        </li>
      </ul>
    </div>

    <div class="face4">
      <div class="title">会员营销管理，高效沉淀更多客户</div>
      <ul>
        <li>
          <img src="../../assets/images/face13.png" />
          <span>会员管理</span>
          <p>一站式完成会员注册、编辑、查看、导入等操作</p>
        </li>
        <li>
          <img src="../../assets/images/face14.png" />
          <span>会员储值</span>
          <p>储值规则设定秘书局可查打通线上、线下储值闭环</p>
        </li>
        <li>
          <img src="../../assets/images/face15.png" />
          <span>优惠卡券</span>
          <p>卡券可同步至微信卡包到期自动提醒，使用更方便</p>
        </li>
        <li>
          <img src="../../assets/images/face16.png" />
          <span>积分兑换</span>
          <p>积分可兑换奖励吸引新客，促进会员消费</p>
        </li>
      </ul>
    </div>

    <div class="face5">
      <div class="title" style="padding:1rem 0">多重产品优势，打造核心竞争力</div>
      <ul>
        <li>
          <div class="left">
            <img src="../../assets/images/face18.png" />
          </div>
          <div class="right">
            <span>支付更高效</span>
            <p>人脸支付识别耗时更低，节约支付等待时间，支付更高效</p>
          </div>
        </li>
        <li>
          <div class="left">
            <img src="../../assets/images/face18.png" />
          </div>
          <div class="right">
            <span>交易更安全</span>
            <p>全新识别技术，手机，脸部双重认证，交易安全可靠</p>
          </div>
        </li>
        <li>
          <div class="left">
            <img src="../../assets/images/face18.png" />
          </div>
          <div class="right">
            <span>运营更精准</span>
            <p>行业流量转化为平台自有流量，打造私域流量池，用户运营更精准</p>
          </div>
        </li>
        <li>
          <div class="left">
            <img src="../../assets/images/face18.png" />
          </div>
          <div class="right">
            <span>支付体验升级</span>
            <p>刷脸付款，全新的支付体验，提高店铺形象</p>
          </div>
        </li>
      </ul>
    </div>

    <div class="face6">
      <div class="title" style="padding:1rem 0">更多盈利模式，加速商业化进程</div>
      <ul>
        <li>
          <img src="../../assets/images/face19.jpg" />
          <span>流水分润</span>
          <p>
            商户的每一笔交易
            <br />都可获取分润
          </p>
        </li>
        <li>
          <img src="../../assets/images/face20.jpg" />
          <span>广告收益</span>
          <p>
            多种展现形式
            <br />获取更高收益
          </p>
        </li>
        <li>
          <img src="../../assets/images/face21.jpg" />
          <span>加盟费用</span>
          <p>
            发展更多合作商户
            <br />收取合作费用
          </p>
        </li>
        <li>
          <img src="../../assets/images/face22.jpg" />
          <span>政策补贴</span>
          <p>
            官方政策补贴、开
            <br />户补贴、费率补贴
          </p>
        </li>
      </ul>
    </div>

    <div class="face7">
      <div class="title" style="padding:1rem 0">优质服务，平台运营稳定有保障</div>
      <ul>
        <li>
          <div class="left">
            <img src="../../assets/images/face24.png" />
          </div>
          <div class="right">
            <span>行业巨头官方合作</span>
            <p>
              返佣盈利官方结算
              <br />资金安全更有保障
            </p>
          </div>
        </li>
        <li>
          <div class="left">
            <img src="../../assets/images/face25.png" />
          </div>
          <div class="right">
            <span>专业第三方服务</span>
            <p>1v1专业服务，确保系统上线、维护等问题第一时间解决</p>
          </div>
        </li>
        <li>
          <div class="left">
            <img src="../../assets/images/face26.png" />
          </div>
          <div class="right">
            <span>专业独立部署</span>
            <p>数据资源尽在掌握，打造专属于您的刷脸支付系统</p>
          </div>
        </li>
        <li>
          <div class="left">
            <img src="../../assets/images/face27.png" />
          </div>
          <div class="right">
            <span>完善技术支持</span>
            <p>强大技术团队，为您提供完整的技术指导和行业支持</p>
          </div>
        </li>
      </ul>
    </div>
    <div class="face8">
      <div class="top">
        <span>硬件轻松安装，数据实时共享</span>
        <p>
          智能终端交易信息同步商户系统后台，
          <br />数据实时查看，对账轻松方便
        </p>
      </div>
      <div class="item">
        <h2>青蛙支付</h2>
        <ul>
          <li>
            <i></i>
            <span>成本更低</span>
          </li>
          <li>
            <i></i>
            <span>便利性高</span>
          </li>
          <li>
            <i></i>
            <span>即插即用</span>
          </li>
          <li>
            <i></i>
            <span>体验更好</span>
          </li>
        </ul>
      </div>
      <div class="item">
        <h2>蜻蜓支付</h2>
        <ul>
          <li>
            <i></i>
            <span>快捷使用</span>
          </li>
          <li>
            <i></i>
            <span>操作简单</span>
          </li>
          <li>
            <i></i>
            <span>轻松支付</span>
          </li>
          <li>
            <i></i>
            <span>一秒识别</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "brushFace",

  data() {
    return {};
  },
  mounted() {},

  methods: {},
};
</script>
<style lang='less' scoped>
.warp {
  background-color: #ecedf0;
  padding-top: 1.45rem;
  box-sizing: border-box;
  padding-bottom: 1.2rem;
  .banner {
    background: url("../../assets/images/face01.jpg") no-repeat left top;
    background-size: 100% auto;
    height: 7rem;
    padding: 0 0.5rem;
    padding-top: 2rem;
    color: #fff;
    p {
      font-size: 0.6rem;
    }
    span {
      font-size: 0.36rem;
      line-height: 0.6rem;
      display: block;
      padding-top: 0.2rem;
    }
    a {
      background-color: #ffa351;
      width: 3rem;
      height: 0.9rem;
      text-align: center;
      color: #fff;
      font-size: 0.36rem;
      border-radius: 0.9rem;
      margin-top: 0.5rem;
      line-height: 0.9rem;
      display: block;
    }
  }
  .title {
    font-size: 0.5rem;
    color: #262e43;
    text-align: center;
    padding: 0.8rem 0;
  }

  .face1 {
    padding: 0.6rem 0.3rem;
    background-color: #fff;
    border-style: solid;
    border-color: #262e43;
    border-width: 0.15rem 0;
    box-shadow: 0px 0px 1rem 0px rgba(26, 26, 26, 0.2);
    position: relative;
    z-index: 999;
    ul {
      display: flex;
      flex-wrap: wrap;
      text-align: center;
      li {
        width: 33.3333%;
        padding-bottom: 0.8rem;
        img {
          width: 1.6rem;
        }
        span {
          display: block;
          font-size: 0.32rem;
          font-weight: 500;
          padding: 0.2rem 0 0.1rem;
        }
        p {
          font-size: 0.3rem;
          color: #888;
          padding: 0 0.1rem;
        }
      }
    }
  }
  .face2 {
    padding: 0.6rem 0.3rem;
    background-color: #fff;
  }
  .face3 {
    padding: 0.6rem 0.3rem;
    background-color: #fff;
    margin-top: 0.45rem;
    ul {
      padding: 0.3rem 0 0 1.2rem;
      li {
        display: flex;
        padding-bottom: 0.6rem;
        .left {
          padding-top: 0.2rem;
          padding-right: 0.1rem;
          img {
            width: 0.2rem;
          }
        }
        .right {
          span {
            font-size: 0.4rem;
            color: #262e43;
            display: block;
            line-height: 0.8rem;
          }
          p {
            font-size: 0.28rem;
          }
        }
      }
    }
  }
  .face4 {
    padding: 0.6rem 0.3rem;
    background-color: #fff;
    margin-top: 0.45rem;
    ul {
      display: flex;
      flex-wrap: wrap;
      li {
        width: 46%;
        margin: 0 2%;
        border: 1px solid #eee;
        text-align: center;
        padding: 0.6rem 0.5rem;
        margin-bottom: 0.4rem;
        img {
          width: 1rem;
        }
        span {
          display: block;
          font-size: 0.34rem;
          color: #262e43;
          font-weight: 500;
          padding: 0.3rem 0 0.2rem;
        }
        p {
          font-size: 0.3rem;
          color: #666666;
        }
      }
    }
  }
  .face5 {
    background: url("../../assets/images/face17.jpg") no-repeat center center;
    background-size: 100% auto;
    height: 10.55rem;
    .title {
      color: #fff;
    }
    ul {
      display: flex;
      flex-wrap: wrap;
      li {
        width: 46%;
        margin: 0 2%;
        background-color: rgba(255, 255, 255, 0.1);
        border-radius: 0.1rem;
        padding: 0.3rem;
        padding-right: 0.5rem;
        display: flex;
        margin-bottom: 0.8rem;
        .left {
          padding: 0.2rem;
          img {
            width: 1rem;
          }
        }
        .right {
          span {
            font-size: 0.34rem;
            color: #fff;
            display: block;
            padding-bottom: 0.1rem;
          }
          p {
            font-size: 0.3rem;
            line-height: 0.55rem;
            color: #fff;
            opacity: 0.8;
          }
        }
      }
    }
  }
  .face6 {
    padding: 0.3rem 0.3rem;
    background-color: #fff;
    ul {
      display: flex;
      flex-wrap: wrap;
      li {
        width: 50%;
        text-align: center;
        padding-bottom: 1rem;
        img {
          width: 2.8rem;
        }
        span {
          display: block;
          font-size: 0.4rem;
          color: #262e43;
          padding: 0.3rem 0 0.1rem;
        }
        p {
          font-size: 0.3rem;
          padding: 0.2rem;
        }
      }
    }
  }
  .face7 {
    height: 13.62rem;
    background: url("../../assets/images/face23.jpg") no-repeat center center;
    background-size: 100% auto;
    .title {
      color: #fff;
    }
    ul {
      display: flex;
      flex-wrap: wrap;
      padding-top: 3.5rem;
      li {
        width: 46%;
        margin: 0.5rem 2% 0;
        background-color: rgba(27, 19, 65, 0.5);
        border-radius: 0.1rem;
        padding: 0.4rem;
        display: flex;
        .left {
          padding-right: 0.15rem;
          img {
            width: 0.5rem;
            height: 0.5rem;
          }
        }
        .right {
          flex: 1;
          span {
            font-size: 0.36rem;
            font-weight: 500;
            color: #fff;
            display: block;
            padding-bottom: 0.1rem;
          }
          p {
            font-size: 0.3rem;
            opacity: 0.8;
            line-height: 0.45rem;
            color: #fff;
          }
        }
      }
    }
  }
  .face8 {
    height: 12.15rem;
    background: url("../../assets/images/face28.jpg") no-repeat center center;
    background-size: 100% auto;
    padding: 0 0.4rem;
    margin-bottom: -1rem;
    .top {
      padding-top: 1.7rem;
      padding-bottom: 0.5rem;
      span {
        font-size: 0.5rem;
        color: #262e43;
        display: block;
        padding-bottom: 0.2rem;
        font-weight: 500;
      }
      p {
        color: #262e43;
        font-size: 0.3rem;
        line-height: 0.5rem;
      }
    }
    .item {
      padding-top: 0.8rem;
      h2 {
        display: inline-block;
        font-size: 0.44rem;
        font-weight: 500;
        border-bottom: 1px solid #262e43;
        color: #262e43;
        margin-bottom: 0.2rem;
        line-height: 0.8rem;
      }
      ul {
        display: flex;
        flex-wrap: wrap;
        width: 4.5rem;
        li {
          width: 1.8rem;
          display: flex;
          align-items: center;
          span {
            line-height: 0.75rem;
            font-size: 0.3rem;
          }
          i {
            width: 6px;
            height: 6px;
            border: 1px solid #262e43;
            border-radius: 10px;
            margin-right: 4px;
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/product/brushFace.vue